import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useApiErrorHandler } from 'src/hooks/useApiErrorHandler';
import useUserLogged from 'src/hooks/useUserLogged';
import { useLazyGetUserAccountsQuery } from 'src/redux/api/account';
import { useMetadataMutation } from 'src/redux/api/auth';
import { metadataCompleted, updateCurrentUser } from 'src/redux/slices/auth';
import CustomSelect from 'src/screens/shared/components/CustomSelect/CustomSelect';

type Props = {
  onSubmit: () => void;
};

const AccountSelector = ({ onSubmit }: Props) => {
  const { currentUser, currentAccount, isSuperAdminOnlyLogged } = useUserLogged();
  const [metadata] = useMetadataMutation();
  const [getUserAccounts] = useLazyGetUserAccountsQuery();
  const dispatch = useDispatch();
  const handleError = useApiErrorHandler();

  useEffect(() => {
    if (currentUser?.id && !isSuperAdminOnlyLogged) {
      getUserAccounts(currentUser.id)
        .unwrap()
        .then((response) => {
          const updatedUser = {
            ...currentUser,
            accounts: {
              data: response.data,
            },
          };
          dispatch(updateCurrentUser(updatedUser));
        })
        .catch((e) => {
          handleError(e);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.id, isSuperAdminOnlyLogged]);

  if (!currentAccount || isSuperAdminOnlyLogged) return null;

  const handleItemSelected = (id: number) => {
    metadata(id)
      .unwrap()
      .then((response) => {
        dispatch(metadataCompleted(response.data));
        onSubmit();
      })
      .catch((e) => {
        handleError(e);
      });
  };

  return currentAccount?.name ? (
    <>
      <CustomSelect
        defaultValue={currentAccount.name}
        style={{ width: 160 }}
        onChange={(accountId) => {
          handleItemSelected(parseInt(accountId, 10));
        }}
        options={currentUser?.accounts.data.map((account) => ({
          value: account.id,
          label: account.name,
        }))}
        popupClassName="account-selector-options"
      />
    </>
  ) : null;
};

export default AccountSelector;
